import { IDocument } from "app/bundles/requests/shared/models/document";
import { Observable } from "rxjs";
import {
  IGeojsonRequestDTO,
  IRawGeojsonRequest,
} from "../../models/geojsonRequest";
import { IServiceRequestProperties } from "../../models/properties";
import {
  IRawServiceRequestDetail,
  IRawServiceRequestSummary,
  IWorkorderRequestDetail,
  IWorkorderRequestShallowDetail,
  IWorkorderRequestSummary,
} from "../../models/request";
import { ReturnDDSDocument } from "../../models/returnDDSDocument";

export abstract class RequestApi {
  public abstract getWorkorderById(
    id: number,
  ): Observable<IWorkorderRequestShallowDetail>;
  public abstract getServiceRequestById(
    id: number,
  ): Observable<IRawServiceRequestDetail>;
  public abstract getDocumentsByWorkorderId(
    id: number,
  ): Observable<IDocument[]>;
  public abstract addDocumentByWorkorderId(
    id: string,
    document: any,
  ): Observable<any>;
  public abstract getWorkorderGeojsonData(): Observable<IRawGeojsonRequest>;
  public abstract getServiceRequestGeojsonData(): Observable<
    IGeojsonRequestDTO<IServiceRequestProperties>
  >;
  public abstract returnDDS(
    id: number,
    document: ReturnDDSDocument,
  ): Observable<any>;
}
